export default __webpack_public_path__ + "169a0788393cae4ee013250a43a9ed81.png";